import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 48px 24px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
`;

const Message = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 24px;
  max-width: 480px;
`;

const ReloadButton = styled.button`
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #4f46e5;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #4338ca;
  }
`;

interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

export default function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  const handleReload = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  return (
    <Container>
      <Title>Something went wrong</Title>
      <Message>
        An unexpected error occurred. Please try reloading the page.
        {import.meta.env.DEV && error?.message && (
          <span style={{ display: 'block', marginTop: 8, fontSize: 13, fontFamily: 'monospace' }}>
            {error.message}
          </span>
        )}
      </Message>
      <ReloadButton onClick={handleReload}>Reload page</ReloadButton>
    </Container>
  );
}
